import { http } from '../helpers/http'

const findAll = () => {
  return http.get('/users')
}

const find = userId => {
  return http.get(`/user/${userId}/informations`)
}

const create = user => {
  return http.post('/user/create', user)
}

const update = (id, user) => {
  return http.post(`/user/${id}`, user)
}

const remove = userId => {
  return http.delete(`user/${userId}`)
}

const updateRole = (userId, role) => {
  return http.patch(`/user/${userId}`, { roles: [role] })
}

export const userService = {
  find,
  findAll,
  create,
  updateRole,
  update,
  remove
}
